function hasNoNullLineItems(list) {
    return list.every(function (item) { return item.groupId !== null && item.groupId !== undefined && item.groupId !== 'null'; });
}
export default hasNoNullLineItems;
